module.exports = __webpack_public_path__ + "img/vn.657376b2.webp";